import { motion } from "framer-motion";
import { Box } from "@mui/joy";

const ease = [0.16, 1, 0.3, 1];

// Scroll-triggered reveal wrapper
export function Reveal({
  children,
  delay = 0,
  y = 28,
  className = "",
  ...rest
}) {
  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{
        duration: 0.8,
        ease,
        delay,
      }}
      className={className}
      sx={{
        width: "100%",
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

// Masked line-by-line text reveal for headings.
// lines: array of strings.
export function MaskedLines({
  lines,
  className = "",
  delay = 0,
  lineClassName = "",
}) {
  return (
    <Box
      component="span"
      className={className}
      aria-label={lines.join(" ")}
      sx={{
        display: "inline-block",
      }}
    >
      {lines.map((line, i) => (
        <Box
          key={i}
          component="span"
          aria-hidden="true"
          sx={{
            display: "block",
            overflow: "hidden",
            paddingBottom: "0.08em",
          }}
        >
          <Box
            component={motion.span}
            className={lineClassName}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1,
              ease,
              delay: delay + i * 0.12,
            }}
            sx={{
              display: "block",
            }}
          >
            {line}
          </Box>
        </Box>
      ))}
    </Box>
  );
}